import React from "react";
import { Link } from "react-router-dom";
import PageStore from "../../Components/PageStore/PageStore";
import { IoIosArrowForward } from "react-icons/io";
import "./OilFilter.css";

const OilFilter = () => {
  return (
    <div>
      <div className="bg_banner_about ">
        <h1>Oil Filter</h1>
        <div className="bread_craum">
          <Link
            to="/"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            Home
          </Link>
          <IoIosArrowForward style={{ color: "#0F172B", marginTop: "4px" }} />
          <Link
            to="/"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            Oil Filter
          </Link>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <h2
              style={{
                borderColor: "orange",
                width: "fit-content",
                borderLeftStyle: "solid",
                backgroundColor: "#474065",
                padding: "5px",
                color: "white",
                marginTop: "14px",
                marginBottom: "36px",
              }}
            >
              Oil Filter
            </h2>
            <PageStore />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OilFilter;
